import {
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  CardActions,
  Link as MuiLink,
  Typography,
  CardHeader,
  Button,
  Grid2,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Menu,
  MenuItem,
  LinearProgress,
  TextField
} from '@mui/material';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import UploadIcon from '@mui/icons-material/Upload';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Link, useParams } from 'react-router-dom'
import { useAuth } from '../../../AuthContext';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import printFilesize from '../../../utils/filesize';
import { useSnackbar } from 'notistack';

const MAX_SIZE = 1_000_000;

function ReleaseRow(props) {
  const { course, release, onPublish } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <TableRow key={release.key}>
      <TableCell>{release.key.split('/').pop()}</TableCell>
      <TableCell>{release.createdAt.split('T')[0]}</TableCell>
      <TableCell>{release.filesize ? printFilesize(release.filesize) : '-'}</TableCell>
      <TableCell>
        <Chip
          color={course.version === release.version ? 'primary' : 'secondary'}
          label={[`v${release.version}`, course.version === release.version && '(Current)'].filter(Boolean).join(' ')}
          sx={{ mr: 1 }}
        />
        {/* {course.version === release.version ? (
          <Chip label="Current" variant="outlined" color="primary" />
        ) : null} */}
      </TableCell>
      <TableCell>
        <IconButton edge="end" aria-label="options" onClick={handleClick}>
          <MoreHorizIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleClose}
          slotProps={{
            list: {
              'aria-labelledby': 'basic-button',
            },
          }}
        >
          <MenuItem onClick={() => { onPublish(release); handleClose(); }}>Publish This Version</MenuItem>
          <MenuItem onClick={handleClose}>Remove</MenuItem>
        </Menu>
      </TableCell>
    </TableRow>
  )
}

export default function EditCourse() {
  const auth = useAuth();
  const params = useParams();
  const fileInput = useRef();
  const imageInput = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [imageKey, setImageKey] = useState();
  const [course, setCourse] = useState();
  const [courseTemp, setCourseTemp] = useState();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [uploadState, setUploadState] = useState({ uploading: false, filename: '', complete: false, progress: 0 });

  const sortedReleases = useMemo(() => {
    return course?.releases?.sort((a, b) => a.version > b.version ? -1 : 1) || [];
  }, [course?.releases]);



  const selectFile = (event) => {
    fileInput.current.click(event);
  }
  const handleFileChange = async (event) => {
    try {

      const file = event.target.files[0];

      if (!file) {
        return;
      }
      setUploadState(old => ({ ...old, uploading: true, filename: file.name, progress: 0 }));

      const partSize = 10 * 1024 * 1024; // 50MB per part (5MB minimum for S3 multipart)
      const parts = [];
      let partNumber = 1;
      const initResponse = await auth.request(`/api/developer/upload/init`, { courseId: params.courseId });
      console.log(initResponse);
      const key = initResponse.data?.Key;
      const uploadId = initResponse.data?.UploadId;
      if (!key || !uploadId) {
        console.error('Missing key or uploadId in response');
        return;
      }

      let bytesUploaded = 0;
      for (let start = 0; start < file.size; start += partSize) {
        const chunk = file.slice(start, start + partSize);
        // const formData = new FormData();
        // formData.append('chunk', chunk);
        // formData.append('uploadId', uploadId);
        // formData.append('key', key);
        // formData.append('partNumber', partNumber);

        console.log(`Uploading part ${partNumber}...`);
        const signResponse = await auth.request('/api/developer/upload/sign', {
          key,
          uploadId,
          partNumber
        });
        if (!signResponse.data?.url) {
          console.error('Missing signed URL in response');
          return;
        }
        console.log(signResponse);
        const resp = await fetch(signResponse.data.url, {
          method: 'PUT',
          // headers: { /* S3 expects no additional headers unless required */ },
          body: chunk,
          // mode: "cors",
          headers: {
            "Content-Type": 'application/octet-stream'
          },
        });

        // setUploadState(old => ({ ...old, uploading: true, filename: file.name, progress: 0 }));
        const progress = bytesUploaded / file.size;
        setUploadState(old => ({ ...old, uploading: true, progress }));

        console.log('resp.headers', resp.headers.keys());
        const etag = resp.headers.get('Etag');
        parts.push({ etag, partNumber });
        partNumber++;
        bytesUploaded += chunk.size;
      }

      const completeResponse = await auth.request(`/api/developer/upload/complete`, {
        courseId: params.courseId,
        filesize: file.size,
        filename: file.name,
        key,
        uploadId,
        parts
      });
      console.log('completeResponse', completeResponse);

      setUploadState(old => ({ ...old, uploading: false, progress: 1, complete: true }));
      await fetchCourseDetails();

      enqueueSnackbar('Upload completed!', { variant: 'success' });


    } catch (error) {
      enqueueSnackbar(error.message || error || 'Encountered an unknown error during upload', { variant: 'error' });
    }
  }

  const selectPoster = (event) => {
    imageInput.current.click(event);
  }
  const selectImage = (event, key) => {
    setImageKey(key);
    imageInput.current.click(event);
  }

  const handlePosterInputChange = useCallback(async (event) => {
    try {
      const file = event.target.files[0];
      if (file.size > MAX_SIZE) {
        throw new Error(`File exceeded maximum size of ${printFilesize(MAX_SIZE)}`);
      }
      console.log('file', file);
      const formData = new FormData();
      formData.append('image', file);
      formData.append('courseId', params.courseId);
      formData.append('imageKey', imageKey);

      const uploadResponse = await auth.request('/api/developer/upload/image', {}, {
        body: formData,
        headers: {}
      });
      if (uploadResponse.data?.error) {
        throw new Error(uploadResponse.data.error);
      }
      console.log('uploadResponse', uploadResponse);
      enqueueSnackbar('Successfully updated poster', { variant: 'success' });
      await fetchCourseDetails();

    } catch (error) {
      enqueueSnackbar(error.message || error || 'Encountered an unknown error during upload', { variant: 'error' });
    }

  }, [params.courseId, imageKey]);


  const handlePublishVersion = async (release) => {
    console.log(release);
    const result = await auth.request('/api/developer/version/publish', {
      courseId: params.courseId,
      version: release.version
    });
    console.log(result);
    await fetchCourseDetails();
    // handleClose();
  }

  const fetchCourseDetails = useCallback(async () => {
    const result = await auth.request(`/api/developer/get/${params.courseId}`);
    console.log(result);
    if (result.data.course) {
      setCourse(result.data.course);
      setCourseTemp(result.data.course);
    }
  }, [auth, params.courseId]);

  const handleTitleChange = (e) => {
    setCourseTemp(old => ({ ...old, title: e.target.value }));
  }
  const handleDescriptionChange = (e) => {
    setCourseTemp(old => ({ ...old, title: e.target.value }));
  }
  const handlePriceChange = (e) => {
    setCourseTemp(old => ({ ...old, price: parseFloat(e.target.value) }));
  }

  useEffect(() => {
    console.log('get', params.courseId);
    fetchCourseDetails();
  }, []);

  if (!course) {
    return;
  }
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Breadcrumbs>
        <MuiLink component={Link} to="/account/developer/">Courses</MuiLink>
        <Typography>{course.title}</Typography>
      </Breadcrumbs>

      <Card sx={{ mt: 3 }}>
        <CardHeader title="Course Details" />
        <CardContent>
          <Grid2 container spacing={3} sx={{ mt: 3 }}>

            <Grid2 size={10} offset={1}>
              <TextField
                label="Name"
                value={courseTemp.title}
                fullWidth={true}
                onChange={handleTitleChange}
              />
            </Grid2>
            <Grid2 size={10} offset={1}>
              <TextField
                label="Description"
                value={courseTemp.description}
                multiline={true}
                onChange={handleDescriptionChange}
                fullWidth={true}
              />
            </Grid2>
            <Grid2 size={10} offset={1}>
              <Typography>${courseTemp.price}</Typography>
                {/* <TextField
                  label="Price"
                  select={true}
                  fullWidth={true}
                  value={parseFloat(courseTemp.price)}
                  onChange={handlePriceChange}
                >
                  <MenuItem value="2.99">$2.99</MenuItem>
                  <MenuItem value="4.99">$4.99</MenuItem>
                  <MenuItem value="9.99">$9.99</MenuItem>
                  <MenuItem value="19.99">$19.99</MenuItem>
                </TextField> */}

            </Grid2>
            <Grid2 size={10} offset={1}>
              <Box
                sx={theme => ({
                  mb: 2,
                  width: 320,
                  height: 180,
                  backgroundColor: theme.palette.grey[700],
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                })}
              >
                {course.posterUrl ? (
                  <a href={course.posterUrl} rel="noreferrer" target="_blank"><img src={course.posterUrl} alt="Poster" width="320" height="180" /></a>
                ) : <Typography color="textSecondary">No Image</Typography>}
              </Box>
              <input style={{ visibility: 'hidden', display: 'none' }} type="file" ref={imageInput} accept=".jpg" onChange={handlePosterInputChange} />
              <Button onClick={selectPoster}>Upload Poster</Button>
            </Grid2>
            <Grid2 size={10} offset={1}>
              <Box
                sx={theme => ({
                  mb: 2,
                  width: 320,
                  height: 180,
                  backgroundColor: theme.palette.grey[700],
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                })}
              >
                {course.posterUrl ? (
                  <a href={course.posterUrl} rel="noreferrer" target="_blank"><img src={course.posterUrl} alt="Poster" width="320" height="180" /></a>
                ) : <Typography color="textSecondary">No Image</Typography>}
              </Box>
              <input style={{ visibility: 'hidden', display: 'none' }} type="file" ref={imageInput} accept=".jpg" onChange={handlePosterInputChange} />
              <Button onClick={(event) => selectImage(event, 'bannerUrl')}>Upload Poster</Button>
            </Grid2>

          </Grid2>
        </CardContent>
        <CardActions sx={{ justifyContent: 'flex-end' }}>
          <Button disabled={!isFormDirty} variant="outlined">Save Changes</Button>
        </CardActions>
      </Card>

      <Card sx={{ mt: 3 }}>
        <CardHeader title="Versions" />
        <CardActions sx={{ justifyContent: 'flex-end' }}>
          <Button
            startIcon={<UploadIcon />}
            onClick={selectFile}
            disabled={uploadState.uploading}
          >
            Upload New Version
          </Button>
        </CardActions>
        <CardContent>
          <Table>
            <TableBody>
              {uploadState.uploading ? (
                <TableRow>
                  <TableCell>
                    {uploadState.filename}
                  </TableCell>
                  <TableCell colSpan={3}>
                    <LinearProgress variant="determinate" value={uploadState.progress * 100} />
                    <Typography>Uploading {(uploadState.progress * 100).toFixed(1)}%</Typography>
                  </TableCell>
                </TableRow>
              ) : null}
              {sortedReleases?.map(release => (
                <ReleaseRow key={release.key} course={course} release={release} onPublish={handlePublishVersion} />
              ))}
            </TableBody>
          </Table>

        </CardContent>
      </Card>
      <input
        type="file"
        style={{ display: 'none', visibility: 'hidden' }}
        accept='.glb'
        ref={fileInput}
        onChange={handleFileChange}
      />
    </Box>
  );
}